import React from 'react';
import { Footer } from './styled';
import { Logo } from 'ui';
import { SocialMedia, Copyright } from 'components/Molecules';
import Links from './Links';


const index = () => {
  return (
    <Footer>
      <Logo/>
      <SocialMedia/>
      <Links/>
      <Copyright/>
    </Footer>
  )
}

export default index
